import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
  Router,
  RouteRecordRaw,
} from 'vue-router'
import {useCurrentAppPlatform} from '@toolify/client/src/modules/platform/composables/useCurrentAppPlatform'

export function setupRouter(routes: RouteRecordRaw[]): Router {
  const {isAppPlatformMobile} = useCurrentAppPlatform()
  const history = isAppPlatformMobile ? createWebHashHistory() : createWebHistory()
  return createRouter({
    history,
    routes,
  })
}
